export const publicSchoollistColumn = [
    {
        label: "s_n",
        name: "S.N"
    },
    {
        label: "schoolName",
        name: "School Name"
    },
    {
        label: "schoolId",
        name: "School ID"
    },
    {
        label: "schoolAddress1",
        name: "School Address"
    },
    {
        label: "blockName",
        name: "Block"
    },
    {
        label: "districtName",
        name: "District"
    },
    {
        label: "pinCode",
        name: "Pincode"
    },
    {
        label: "schoolType",
        name: "School Type"
    },

    {
        label: "schoolMedium",
        name: "Medium of Instruction"
    },
    {
        label: "boardOfEducation",
        name: "Board Of Education",
    },
    {
        label: "levelOfEducation",
        name: "Level Of Education"
    },
    {
        label: "highestClass",
        name: "Highest Class"
    }
];